import 'css-chunk:src/applications/ProductFulfillmentApp/NoCatalogueProductSelection/components/ProjectConfigSetup/ProjectConfigSetup.scss';export default {
  "ProjectConfigSetup": "_ProjectConfigSetup_3wxjq_1",
  "content": "_content_3wxjq_7",
  "formItems": "_formItems_3wxjq_12",
  "checkboxGroup": "_checkboxGroup_3wxjq_20",
  "checkboxes": "_checkboxes_3wxjq_24",
  "fieldConfigurations": "_fieldConfigurations_3wxjq_31"
};